import classnames from 'classnames';
import { childrenFunc } from '../../utils/childrenFunc';
import CardBody from './CardBody';
import CardFooter from './CardFooter';
import CardHeader from './CardHeader';
import { createElement } from 'react';
import './style.less';
Card.defaultProps = {
    prefixCls: 'im-card',
    full: false,
    noline: false,
    showHeadLine: true,
    showSeparatorLine: false,
};
function Card(props) {
    const { prefixCls, full, title, titleExtra, thumb, thumbStyle, titleStyle, body, bodyStyle, footer, footerExtra, footerStyle, className, bgImg, showHeadLine, showSeparatorLine, noline, subTitle, subtitle, subStyle, substyle, borderStyle, borderRadius, ...resetProps } = props;
    const propsMap = {
        body: body,
        footer: footer,
        subTitle: subTitle,
        subStyle: subStyle,
        showHeadLine: showHeadLine,
    };
    const wrapCls = classnames(prefixCls, className, {
        [`${prefixCls}-full`]: full,
        [`${prefixCls}-full-seperator-line`]: showSeparatorLine,
    });
    let backgroundImageSrc;
    if (bgImg) {
        backgroundImageSrc = `url(${bgImg})`;
    }
    else {
        backgroundImageSrc = '';
    }
    const cardContent = (createElement("div", Object.assign({ className: wrapCls }, resetProps, { style: {
            backgroundImage: backgroundImageSrc,
            backgroundSize: 'cover',
            borderBottom: borderStyle,
            borderRadius: `${borderRadius}px`,
        } }),
        title ? (createElement(CardHeader, { prefixCls: prefixCls, title: title, extra: titleExtra, thumb: thumb, subTitle: propsMap.subTitle, subStyle: propsMap.subStyle, thumbStyle: thumbStyle, style: titleStyle, showHeadLine: propsMap.showHeadLine })) : null,
        propsMap.body ? (createElement(CardBody, { prefixCls: prefixCls, full: full, style: bodyStyle, content: childrenFunc(propsMap.body) })) : null,
        propsMap.footer ? (createElement(CardFooter, { prefixCls: prefixCls, content: childrenFunc(propsMap.footer), extra: childrenFunc(footerExtra), style: footerStyle })) : null));
    return cardContent;
}
export default Card;
export { CardPropsType } from './PropsType';
